import type { PropsWithChildren } from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const styles = tv({
  base: "items-baseline text-base [&>svg]:size-[1em] [&>svg]:translate-y-[0.125em]",
  variants: {
    size: {
      large: "text-lg",
      small: "text-sm",
      "x-small": "text-xs",
    },
    align: {
      center: "text-center",
    },
    color: {
      "dark-neutral": "text-neutral-950",
      neutral: "text-neutral-800",
      "light-neutral": "text-neutral-700",

      success: "text-green-700",
      error: "text-red-700",
      warning: "text-yellow-700",
    },
    weight: {
      bold: "font-semibold",
      medium: "font-medium",
      normal: "font-normal",
    },
    italic: {
      true: "italic",
    },
    lineThrough: {
      true: "line-through",
    },
  },
  defaultVariants: {
    color: "neutral",
    weight: "normal",
  },
});

type HeadingProps = PropsWithChildren<
  Omit<VariantProps<typeof styles>, "className"> & {
    as?: "span" | "div" | "label" | "p";
  }
>;

export const Text = ({
  as = "span",
  size,
  align,
  color,
  weight,
  italic,
  lineThrough,
  children,
  ...props
}: HeadingProps) => {
  const Component = as;

  return (
    <Component
      className={styles({ size, align, color, weight, italic, lineThrough })}
      {...props}
    >
      {children}
    </Component>
  );
};
